import React, {
  useState,
  useEffect,
  useMemo,
  Suspense,
  lazy,
  startTransition,
} from "react";
import axios from "axios";
import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Button,
  Input,
  Col,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import { FaCheck } from "react-icons/fa";
import ProtectedRoute from "./Protected";

// Lazy loading para componentes pesados
const AdjuntosCargadosIndex = lazy(
  () => import("components/Ordenes/AdjuntosCargadosIndex"),
);
const EquiposIntaladosInspec = lazy(() => import("./EquiposIntaladosInspec"));
const InfoVehiculo = lazy(() => import("./InfoVehiculo"));

const Certificado = lazy(() => import("components/Ordenes/Certificado"));
const ActualizaEstadoAdmin = lazy(() => import("./ActualizaEstadoAdmin"));
const CreaComentarios = lazy(() => import("views/Crea/CreaComentarios"));

const OrdenesHistorico = () => {
  const cookie = new Cookies();
  const tipoUsuarioId = cookie.get("tipoUsuarioId");
  const userId = cookie.get("id");

  const [ordenes, setOrdenes] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!tipoUsuarioId) {
      Swal.fire({
        icon: "warning",
        title: "Debe iniciar sesión",
        text: "Por favor, inicie sesión para continuar.",
        confirmButtonText: "Aceptar",
      }).then(() => (window.location.href = "/auth/login"));
    }
  }, [tipoUsuarioId]);

  const getEndpointUrl = () => {
    switch (tipoUsuarioId) {
      case 1:
        return "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerOrdenes/0";
      case 2:
      case 3:
        return `https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerOrdenes/${userId}`;
      default:
        return null;
    }
  };

  const fetchOrdenes = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(getEndpointUrl());
      const sortedData = Array.isArray(data)
        ? data.sort((a, b) => b.id - a.id)
        : [];
      setOrdenes(sortedData);
    } catch (error) {
      console.error("Error fetching ordenes:", error);
      setOrdenes([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrdenes();
  }, []);

  useEffect(() => {
    axios
      .get(
        `https://inspecciongnvback-dev.azurewebsites.net/api/v1/LogueoActivo/${userId}`,
        {
          auth: {
            username: "admin.icontec@icontec.org",
            password: "quAngEraMuSTerGerEDE",
          },
        },
      )
      .then((res) => setUsuarios(res.data))
      .catch((err) => console.error(err));
  }, [userId]);

  const filteredItems = useMemo(() => {
    return ordenes.filter((item) =>
      Object.values(item).some((val) =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [ordenes, searchTerm]);

  const currentItems = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return filteredItems.slice(startIndex, startIndex + itemsPerPage);
  }, [filteredItems, currentPage, itemsPerPage]);

  const isAdmin = tipoUsuarioId == 1;
  const isTaller = tipoUsuarioId == 2;
  const isInspector = tipoUsuarioId == 3;

  const handleItemsPerPageChange = (e) => {
    startTransition(() => {
      setItemsPerPage(Number(e.target.value));
      setCurrentPage(1);
    });
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    startTransition(() => {
      setSearchTerm(value);
    });
  };

  const Crear = () => (window.location.href = "/admin/CreaPropitario");

  return (
    <ProtectedRoute>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between">
                <h3 className="mb-0">ORDENES DE SERVICIO</h3>
                {isInspector && (
                  <Button className="btn btn-primary btn-lg" onClick={Crear}>
                    Nuevo
                  </Button>
                )}
              </CardHeader>

              <Row className="px-4">
                <Col xl="6">
                  <Input
                    type="text"
                    placeholder="Buscar..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className="mb-3"
                  />
                </Col>
              </Row>

              {loading ? (
                <div className="text-center p-4">Cargando...</div>
              ) : (
                <Suspense
                  fallback={
                    <div className="text-center">Cargando datos...</div>
                  }
                >
                  <Table className="table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th>Id</th>
                        <th>Vehículo</th>
                        <th>Fecha Prestación del Servicio</th>
                        <th>Fecha Creación</th>
                        <th>Taller</th>
                        <th>Tipo Orden</th>
                        <th>Estado</th>
                        <th>Usuario</th>
                        <th>Chip Vehículo</th>
                        <th>Chip Taller</th>
                        <th>Fecha Conversión</th>
                        <th>Anexos</th>
                        <th>Equipos</th>
                        <th>Certificado</th>
                        {!isInspector && <th>Lista</th>}
                        {isAdmin && <th>Estado Admin</th>}
                        {isAdmin && <th>Comentarios</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((item) => (
                        <tr key={item.id}>
                          <td>{item.id}</td>
                          <td>
                            <Suspense
                              fallback={<div>Cargando vehículo...</div>}
                            >
                              <InfoVehiculo vehiculoId={item.vehiculoId} />
                            </Suspense>
                          </td>

                          <td>{item.fechaPrestacionServicio}</td>
                          <td>{item.fechaCreacion}</td>
                          <td>{item.nombreTaller}</td>
                          <td>{item.toservicio}</td>
                          <td>{item.estado}</td>
                          <td>{item.correo}</td>
                          <td>{item.chipVehiculo}</td>
                          <td>{item.chipTaller}</td>
                          <td>{item.fechaConversion}</td>
                          <td>
                            <Suspense fallback={<div>Cargando anexos...</div>}>
                              <AdjuntosCargadosIndex OrdenId={item.id} />
                            </Suspense>
                          </td>
                          <td>
                            <Suspense fallback={<div>Cargando equipos...</div>}>
                              <EquiposIntaladosInspec OrdenId={item.id} />
                            </Suspense>
                          </td>
                          <td>
                            {item.estado === "Presentado" && (
                              <Suspense
                                fallback={<div>Generando certificado...</div>}
                              >
                                <Certificado id={item.id} />
                              </Suspense>
                            )}
                          </td>
                          {!isInspector && (
                            <td>
                              {item.estado === "Presentado" && (
                                <Button
                                  color="success"
                                  title="Ver Resultados"
                                  onClick={() =>
                                    (window.location.href = `/admin/Resultados/${item.id}/${item.vehiculoId}`)
                                  }
                                >
                                  <FaCheck />
                                </Button>
                              )}
                            </td>
                          )}
                          {isAdmin && (
                            <>
                              <td>
                                <Suspense
                                  fallback={<div>Actualizando estado...</div>}
                                >
                                  <ActualizaEstadoAdmin
                                    OrdenId={item.id}
                                    fechaCreacion={item.fechaCreacion}
                                    tipoOrdenServicioId={
                                      item.tipoOrdenServicioId
                                    }
                                    listaChequeoId={item.listaChequeoId}
                                    tipoGas={item.tipoGas}
                                    fechaConversion={item.fechaConversion}
                                    tallerId={item.tallerId}
                                  />
                                </Suspense>
                              </td>
                              <td>
                                <Suspense
                                  fallback={<div>Cargando comentarios...</div>}
                                >
                                  <CreaComentarios OrdenId={item.id} />
                                </Suspense>
                              </td>
                            </>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Suspense>
              )}

              <Row className="px-4 mt-3">
                <Col xl="6">
                  <div className="d-flex align-items-center">
                    <label className="me-2">Mostrar:</label>
                    <Input
                      type="select"
                      value={itemsPerPage}
                      onChange={handleItemsPerPageChange}
                      style={{ width: "100px" }}
                    >
                      {[10, 20, 30, 50, 100].map((num) => (
                        <option key={num} value={num}>
                          {num}
                        </option>
                      ))}
                    </Input>
                  </div>
                </Col>
                <Col xl="6">
                  <CardFooter className="py-2 d-flex justify-content-end">
                    <Pagination>
                      <PaginationItem disabled={currentPage <= 1}>
                        <PaginationLink
                          previous
                          onClick={(e) => {
                            e.preventDefault();
                            startTransition(() =>
                              setCurrentPage((prev) => prev - 1),
                            );
                          }}
                        />
                      </PaginationItem>
                      <PaginationItem disabled>
                        <PaginationLink>
                          Página {currentPage} de{" "}
                          {Math.ceil(filteredItems.length / itemsPerPage)}
                        </PaginationLink>
                      </PaginationItem>
                      <PaginationItem
                        disabled={
                          currentPage >=
                          Math.ceil(filteredItems.length / itemsPerPage)
                        }
                      >
                        <PaginationLink
                          next
                          onClick={(e) => {
                            e.preventDefault();
                            startTransition(() =>
                              setCurrentPage((prev) => prev + 1),
                            );
                          }}
                        />
                      </PaginationItem>
                    </Pagination>
                  </CardFooter>
                </Col>
              </Row>
            </Card>
          </div>
        </Row>
      </Container>
    </ProtectedRoute>
  );
};

export default OrdenesHistorico;
